import React from 'react'
import styles from "./document.module.css"
import Button from '../../../Form/Button'
import { getIconByExtensionFile, openLinkExternal } from '../../../../utils/utils'
import { formatDataSizeInKb } from '../../../../utils/formatter'

const getExtension = (name = "", mimetype = "") => {
    const cleanName = String(name || "")
    const extension = cleanName.includes(".") ? cleanName.split(".").pop() : ""
    if (extension) return extension.toUpperCase()

    const type = String(mimetype || "").split(";")[0].trim().toLowerCase()
    const map = {
        "application/pdf": "PDF",
        "application/vnd.ms-excel": "XLS",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
        "application/msword": "DOC",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
        "application/vnd.ms-powerpoint": "PPT",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPTX",
        "text/plain": "TXT",
        "text/csv": "CSV",
    }

    return map[type] || "ARQ"
}

const Document = ({ name, url, size, mimetype }) => {
    const fileName = name || "Arquivo recebido"
    const extension = getExtension(name, mimetype)
    const iconFileName = fileName.includes(".") ? fileName : `arquivo.${extension.toLowerCase()}`
    const details = [
        extension,
        size ? formatDataSizeInKb(size) : "",
    ].filter(Boolean).join(" • ")

    const handleClick = () => {
        if (url) {
            openLinkExternal(url, true)
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                {getIconByExtensionFile(iconFileName)}
            </div>
            <div className={styles.details} title={fileName}>
                <span className={styles.name}>{fileName}</span>
                <small>{details || "Arquivo"}</small>
            </div>
            <Button className={styles.action} onClick={handleClick}>Abrir</Button>
        </div>
    )
}

export default Document
